import dynamic from 'next/dynamic';
import SearchBox from 'components/common/SearchBox';
import { useTranslations } from 'next-intl';

const GridStarsBackground = dynamic(() => import('./WebGLBackground'), { ssr: false });

export default function HeroSection() {
  const t = useTranslations('support');

  return (
    <section
      data-theme="dark"
      className="relative -mt-16 flex w-full flex-col justify-end bg-base-fill-primary px-4 pb-6 pt-[104px] pad:-mt-16 pad:h-[420px] pad:items-center pad:justify-center pad:pb-0 pad:pt-16"
    >
      <GridStarsBackground className="absolute inset-0" />
      <h1 className="relative z-10 mb-8 text-[28px] font-bold leading-[34px] text-base-label pad:text-center pad:text-4xl pad:leading-tight pc-small:text-[54px] pc-small:leading-[60px]">
        {t('heroTitle')}
      </h1>
      <SearchBox className="relative z-10 w-full max-w-full pad:max-w-[600px]" />
    </section>
  );
}
